import React from 'react';
import { HardHat, ArrowLeft, ArrowRight, CheckCircle, Camera, Copy, Heart, CalendarBlank, CreditCard, DeviceMobile, WhatsappLogo, Star, Wrench, MapPin } from '@phosphor-icons/react';

const BENEFITS = [
  { icon: Camera, title: "Photo → Post en 10 secondes", desc: "Prenez une photo de votre chantier. L'IA rédige le post Facebook/WhatsApp parfait." },
  { icon: Copy, title: "Copier-coller, c'est publié", desc: "Un clic pour copier. Collez sur Facebook ou envoyez sur WhatsApp. Terminé." },
  { icon: MapPin, title: "Adapté à Mayotte", desc: "Posts géolocalisés avec les villes de Mayotte. Ton chaleureux, esprit Karibu." },
  { icon: Wrench, title: "Tous les corps de métier", desc: "Toiture, clim, portail, peinture, carrelage, électricité, maçonnerie, rénovation..." },
  { icon: Heart, title: "Galerie communautaire", desc: "Partagez vos meilleurs projets. Gagnez en visibilité avec les likes." },
  { icon: CalendarBlank, title: "Calendrier intelligent", desc: "L'app vous dit quand poster pour un maximum d'impact à Mayotte." },
];

export default function BriefPage({ onBack, onGetStarted }) {
  const shareWhatsApp = () => {
    const text = `*SHANGA PRO — L'app des artisans BTP à Mayotte*

Vous êtes artisan du BTP à Mayotte ?
Vous voulez plus de clients sans perdre du temps sur les réseaux ?

Shanga Pro fait le travail pour vous :
📸 Prenez une photo de votre chantier
🤖 L'IA génère le post Facebook/WhatsApp parfait
📋 Copiez-collez, c'est publié !

✅ Adapté aux villes de Mayotte (Mamoudzou, Sada, Bandrélé...)
✅ Tous les métiers : toiture, clim, portail, peinture, carrelage...
✅ Mode Avant/Après pour montrer vos transformations
✅ Galerie pour gagner en visibilité
✅ 2 posts d'essai GRATUITS

💰 Ensuite : 17,90€/mois pour des posts illimités

👉 Essayez maintenant : ${window.location.origin}

_Shanga Pro — Transformez vos chantiers en clients._`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const copyBrief = async () => {
    const text = `SHANGA PRO — L'app des artisans BTP à Mayotte

Vous êtes artisan du BTP à Mayotte ?
Vous voulez plus de clients sans perdre du temps sur les réseaux ?

Shanga Pro fait le travail pour vous :
📸 Prenez une photo de votre chantier
🤖 L'IA génère le post Facebook/WhatsApp parfait
📋 Copiez-collez, c'est publié !

✅ Adapté aux villes de Mayotte (Mamoudzou, Sada, Bandrélé...)
✅ Tous les métiers : toiture, clim, portail, peinture, carrelage...
✅ Mode Avant/Après pour montrer vos transformations
✅ Galerie pour gagner en visibilité
✅ 2 posts d'essai GRATUITS

💰 Ensuite : 17,90€/mois pour des posts illimités

👉 Essayez maintenant : ${window.location.origin}

Shanga Pro — Transformez vos chantiers en clients.`;
    try {
      await navigator.clipboard.writeText(text);
      alert('Brief copié ! Vous pouvez le coller sur Facebook, WhatsApp ou par email.');
    } catch (error) {
      console.error("Copy failed:", error.message);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B]" data-testid="brief-page">
      <nav className="bg-[#09090B] border-b border-[#27272A] sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={onBack} className="text-[#A1A1AA] hover:text-[#F4F4F5] transition-colors" data-testid="brief-back-btn">
              <ArrowLeft size={20} />
            </button>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[#8B5CF6] flex items-center justify-center">
                <HardHat size={18} weight="duotone" className="text-white" />
              </div>
              <span className="font-bold text-lg text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Brief</span>
            </div>
          </div>
          <div className="flex gap-2">
            <button onClick={copyBrief} data-testid="copy-brief-btn"
              className="h-9 px-3 text-sm border border-[#27272A] text-[#A1A1AA] rounded-lg hover:bg-[#18181B] hover:text-[#F4F4F5] font-medium flex items-center gap-1.5">
              <Copy size={14} /> Copier
            </button>
            <button onClick={shareWhatsApp} data-testid="share-brief-whatsapp"
              className="h-9 px-3 text-sm bg-[#25D366] text-white rounded-lg hover:bg-[#20BD5A] font-medium flex items-center gap-1.5">
              <WhatsappLogo size={14} weight="fill" /> Partager
            </button>
          </div>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#8B5CF6]/10 border border-[#8B5CF6]/30 rounded-full mb-4">
            <Star size={14} weight="fill" className="text-[#A78BFA]" />
            <span className="text-xs font-bold text-[#A78BFA]">BRIEF DE PRÉSENTATION</span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-black tracking-tighter mb-4 text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            Shanga Pro
          </h1>
          <p className="text-xl text-[#A78BFA] font-medium mb-2" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            L'app marketing des artisans BTP à Mayotte
          </p>
          <p className="text-[#A1A1AA] text-lg max-w-xl mx-auto">
            Transformez chaque photo de chantier en post Facebook ou WhatsApp qui génère des appels de clients.
          </p>
        </div>

        {/* Le problème */}
        <div className="bg-[#18181B] border border-[#27272A] rounded-lg p-6 mb-6 animate-fade-in-up stagger-1">
          <h2 className="font-bold text-lg text-[#F4F4F5] mb-3" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Le problème</h2>
          <div className="space-y-2 text-sm text-[#E4E4E7]">
            <p>Vous faites du bon travail sur vos chantiers, mais :</p>
            <ul className="space-y-1.5 ml-4">
              <li className="flex items-start gap-2"><span className="text-red-400 shrink-0">✗</span> Vous n'avez pas le temps de rédiger des posts</li>
              <li className="flex items-start gap-2"><span className="text-red-400 shrink-0">✗</span> Vous ne savez pas quoi écrire pour attirer des clients</li>
              <li className="flex items-start gap-2"><span className="text-red-400 shrink-0">✗</span> Vos concurrents publient plus que vous</li>
              <li className="flex items-start gap-2"><span className="text-red-400 shrink-0">✗</span> Vous perdez des clients qui ne vous connaissent pas</li>
            </ul>
          </div>
        </div>

        {/* La solution */}
        <div className="bg-[#8B5CF6]/5 border border-[#8B5CF6]/30 rounded-lg p-6 mb-6 animate-fade-in-up stagger-2">
          <h2 className="font-bold text-lg text-[#F4F4F5] mb-3" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>La solution : Shanga Pro</h2>
          <div className="space-y-2 text-sm text-[#E4E4E7]">
            <p className="font-medium text-[#A78BFA]">En 3 gestes, depuis votre chantier :</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
              {[
                { num: "1", title: "Photographiez", desc: "Prenez une photo de votre travail terminé" },
                { num: "2", title: "Générez", desc: "L'IA crée le post parfait avec emojis et appel à l'action" },
                { num: "3", title: "Publiez", desc: "Copiez-collez sur Facebook ou WhatsApp" },
              ].map(s => (
                <div key={s.num} className="text-center p-3 bg-[#09090B] rounded-lg border border-[#27272A]">
                  <div className="w-8 h-8 rounded-full bg-[#8B5CF6] text-white font-bold text-sm flex items-center justify-center mx-auto mb-2">{s.num}</div>
                  <p className="font-bold text-xs text-[#F4F4F5]">{s.title}</p>
                  <p className="text-[10px] text-[#A1A1AA] mt-0.5">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Fonctionnalités */}
        <div className="mb-6">
          <h2 className="font-bold text-lg text-[#F4F4F5] mb-4 text-center" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Ce que Shanga Pro fait pour vous</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {BENEFITS.map(b => (
              <div key={b.title} className="bg-[#18181B] border border-[#27272A] rounded-lg p-4 flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#8B5CF6]/15 flex items-center justify-center shrink-0">
                  <b.icon size={18} weight="duotone" className="text-[#A78BFA]" />
                </div>
                <div>
                  <p className="font-bold text-sm text-[#F4F4F5]">{b.title}</p>
                  <p className="text-xs text-[#A1A1AA] mt-0.5">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tarif */}
        <div className="bg-[#18181B] border border-[#27272A] rounded-lg p-6 mb-6 text-center animate-fade-in-up">
          <h2 className="font-bold text-lg text-[#F4F4F5] mb-4" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Tarif simple</h2>
          <div className="grid grid-cols-2 gap-4 max-w-md mx-auto">
            <div className="border border-[#27272A] rounded-lg p-4">
              <p className="font-bold text-[#F4F4F5]">Essai gratuit</p>
              <p className="text-2xl font-black text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>0€</p>
              <p className="text-xs text-[#71717A] mt-1">2 posts pour tester</p>
            </div>
            <div className="border border-[#8B5CF6] bg-[#8B5CF6]/5 rounded-lg p-4">
              <p className="font-bold text-[#A78BFA]">Pro</p>
              <p className="text-2xl font-black text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>17,90€<span className="text-sm font-normal text-[#71717A]">/mois</span></p>
              <p className="text-xs text-[#71717A] mt-1">Posts illimités</p>
            </div>
          </div>
          <p className="text-xs text-[#71717A] mt-3">Un seul chantier gagné grâce à vos posts rembourse des années d'abonnement.</p>
        </div>

        {/* Exemple de post */}
        <div className="bg-[#18181B] border border-[#27272A] rounded-lg p-6 mb-8">
          <h2 className="font-bold text-lg text-[#F4F4F5] mb-3" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>Exemple de post généré</h2>
          <div className="bg-[#09090B] border border-[#27272A] rounded-lg p-4">
            <p className="text-sm text-[#E4E4E7] leading-relaxed whitespace-pre-wrap">🛠️ Nouveau chantier terminé à Bandrélé !

Nous avons posé une toiture renforcée pour protéger cette maison avant la saison des pluies. 🌧️

✅ Travail soigné et matériaux solides.
✅ Équipe locale, réactive et professionnelle.

Votre maison mérite le meilleur ! 🏠

📞 Contactez-nous en MP pour votre devis gratuit.
📲 Ou appelez-nous directement !</p>
          </div>
          <p className="text-xs text-[#71717A] mt-2 text-center">Généré automatiquement par l'IA de Shanga Pro</p>
        </div>

        {/* CTA */}
        <div className="text-center mb-8">
          <button onClick={onGetStarted} data-testid="brief-cta"
            className="h-14 px-8 bg-[#8B5CF6] text-white font-bold text-base rounded-lg hover:bg-[#7C3AED] transition-colors inline-flex items-center gap-2 animate-glow">
            Essayer Shanga Pro <ArrowRight size={20} weight="bold" />
          </button>
          <p className="text-xs text-[#71717A] mt-3">2 posts gratuits. Sans carte bancaire.</p>
        </div>

        {/* Share buttons */}
        <div className="border-t border-[#27272A] pt-6 text-center">
          <p className="text-sm text-[#A1A1AA] mb-3">Partagez ce brief avec d'autres artisans</p>
          <div className="flex justify-center gap-3">
            <button onClick={shareWhatsApp} data-testid="brief-share-wa"
              className="h-12 px-6 bg-[#25D366]/15 text-[#25D366] border border-[#25D366]/30 rounded-lg font-medium text-sm hover:bg-[#25D366]/25 flex items-center gap-2">
              <WhatsappLogo size={20} weight="fill" /> Envoyer sur WhatsApp
            </button>
            <button onClick={copyBrief} data-testid="brief-copy"
              className="h-12 px-6 bg-[#27272A] text-[#F4F4F5] rounded-lg font-medium text-sm hover:bg-[#3F3F46] flex items-center gap-2">
              <Copy size={18} /> Copier le texte
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
